import axios from "axios";
import { Dispatch } from "redux";
import { PopupAlertData } from "../components/Alert/Popup";
import { API_URL } from "../utils/api";
import { ActionTypes } from "./types";
/**
 * * ****************************** INTERFACES *****************************
 */

export interface System {
  navigation: boolean;
  page_has_sub_nav: boolean;
  PopupAlerts: PopupAlertData[] | null;
}

export interface BranchItem {
  branch: string;
  branch_id: string;
  status: string;
}

//* ********************** ACTION TYPE INTERCACES ********************** */

export interface NavToogleInterface {
  type: ActionTypes.NAVIGATION_TOOGLE;
}

export interface PageHasSubNavInterface {
  type: ActionTypes.PAGE_HAS_SUB_NAV;
  payload: boolean;
}

// Emmy:: Popup alert
export interface PushPopupAlertAction {
  type: ActionTypes.PUSH_POPUP_ALERT;
  payload: PopupAlertData;
}

export interface RemovePopupAlertAction {
  type: ActionTypes.REMOVE_POPUP_ALERT;
}

/**
 * * ****************************** ACTIONS *****************************
 */

/**
 * @description Activate/desactivate navigation
 * @returns null
 */
export const NavToogle = () => {
  return (dispatch: Dispatch) => {
    dispatch<NavToogleInterface>({
      type: ActionTypes.NAVIGATION_TOOGLE,
    });
  };
};

/**
 * @description Activate/desactivate navigation
 * @returns null
 */
export const PageHasSubNav = (status: boolean) => {
  return (dispatch: Dispatch) => {
    dispatch<PageHasSubNavInterface>({
      type: ActionTypes.PAGE_HAS_SUB_NAV,
      payload: status,
    });
  };
};

/**
 * @description Popup alert
 * @returns null
 */

export const PushPopupAlert = (alert: PopupAlertData) => {
  return (dispatch: Dispatch) => {
    dispatch<PushPopupAlertAction>({
      type: ActionTypes.PUSH_POPUP_ALERT,
      payload: alert,
    });
  };
};

export const RemovePopupAlert = () => {
  return async (dispatch: Dispatch) => {
    dispatch<RemovePopupAlertAction>({
      type: ActionTypes.REMOVE_POPUP_ALERT,
    });
  };
};

export const GetBranches = async (
  setLoading: (status: boolean) => void,
  callback: (status: boolean, data: BranchItem[]) => void
) => {
  setLoading(true);
  try {
    const res = await axios.get<BranchItem[]>(`${API_URL}/branch`);
    callback(true, res.data);
    console.log("Branches: ", res);
  } catch (error) {
    callback(false, []);
  }
  setLoading(false);
};
